<template>
    <div class="item-container" @mouseover="hovered = true" @mouseleave="hovered = false">
        <!-- 左上角的 Tag -->
        <div class="tag">{{ tag }}</div>

        <!-- 左下角的 Tag -->
        <div v-if="month" class="month-tag">{{ month }}</div>
        <!-- 图片内容 -->
        <img class="item-image" :src="image" :alt="$t('app.auto_697_23f1290c')" />

        <!-- 悬停蒙层 -->
        <div class="overlay" v-if="hovered">
            <!-- <div class="qr-code-text">{{ hoverText }}</div> -->
            <!-- <img class="qr-code" :src="qrCode" alt="QR Code" /> -->
            <div v-if="buttonType == 'self'" @click="handleAction" class="bottom-button">{{ buttonText }}</div>
            <el-button v-else :type="buttonType" size="mini" round class="action-button" @click="handleAction">
                <i class="el-icon-search"></i> {{ buttonText }}
            </el-button>
        </div>

        <!-- 底部标题 -->
        <div class="title">{{ title }}</div>
    </div>
</template>

<script>
export default {
    name: "item-card",
    props: {
        tag: {
            type: String,
            required: true,
        },
        month: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: true,
        },
        qrCode: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        hoverText: {
            type: String,
            required: true,
        },
        buttonText: {
            type: String,
            required: true,
        },
        buttonType: {
            type: String,
            default: "primary",
        },
        index: {
            type: Number,
            required: true, // 从父组件接收当前索引
        },
    },
    data() {
        return {
            hovered: false, // 悬停状态
        };
    },
    methods: {
        handleAction() {
            this.$emit("action", this.index); // 触发父组件的事件
        },
    },
};
</script>

<style scoped>
/* 卡片容器 */
.item-container {
    width: 200px;
    height: 280px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
    position: relative;
    text-align: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s, box-shadow 0.3s;
}

/* 左上角的 Tag */
.tag {
    position: absolute;
    top: 8px;
    left: 8px;
    background-color: #409eff;
    color: #fff;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    z-index: 10;
}

.month-tag {
    position: absolute;
    bottom: 50px;
    left: 8px;
    background-color: #f6f6f6;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 12px;
    z-index: 10;
}

/* 图片样式 */
.item-image {
    display: flex;
    width: 100%;
    height: 278px;
    object-fit: cover;
}

/* 悬停蒙层 */
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    /* 半透明黑色蒙层 */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    z-index: 999;
    transition: opacity 0.3s ease;
}

/* 二维码文本 */
.qr-code-text {
    font-size: 14px;
    margin-bottom: 8px;
}

/* 二维码样式 */
.qr-code {
    width: 150px;
    height: 150px;
    margin-bottom: 8px;
}

/* 按钮样式 */
.action-button {
    font-size: 14px;
    padding: 10px;
}

/* 底部标题 */
.title {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 99;
    background: #fff;
    opacity: 0.7;
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 14px;
}

.bottom-button {
    cursor: pointer;
    position: absolute;
    bottom: 0ch;
    padding: 10px;
    width: 100%;
    background: #409eff;
}
</style>